"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Compass } from "lucide-react";
export default function Layout() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="174307" id="twocolumnlayout" className="bg-background text-foreground relative w-full overflow-hidden py-16 !h-[650px] md:py-24 lg:py-32 bg-cover bg-center !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/04/Reportage-Suivi-Chantier-OGIC-Jordane-Angot-Photographie-150ppp-4-sur-32.jpg)]">
      <div className="container">
        <div className="grid grid-cols-12 gap-x-4 md:gap-x-6">
          
        </div>
      </div>
    </section>;
}